<!--
 * @Description : 公共页脚
 * @Author      : pishengjun
 * @Date        : 2022-06-08 14:38:37
-->
<template>
  <!-- 页脚 -->
  <div class="footer">
    <div class="item" v-if="webSystemSetting.organizationalUnit">
      组织单位：{{ webSystemSetting.organizationalUnit }}
    </div>
    <div class="item">
      <a class="link" :href="webSystemSetting.copyrightAddress" target="_blank">
        Copyright © {{ year }} {{ webSystemSetting.copyright }} 版权所有
      </a>
    </div>
    <div class="item" v-if="webSystemSetting.icpFiling">
      <a class="link" :href="webSystemSetting.filingAddress" target="_blank">{{ webSystemSetting.icpFiling }}</a>
    </div>
  </div>
</template>

<script lang="ts">
import { store } from "@/store";
import { defineComponent, reactive, toRefs, inject, onMounted } from "vue";

export default defineComponent({
  setup() {
    const state = reactive({
      webSystemSetting: store.state.webSystemSetting,
      year: new Date().getFullYear(),
    });
    onMounted(() => {
    });
    return {
      ...toRefs(state),
    };
  },
});
</script>

<style lang="less" scoped>
.footer {
  text-align: center;
  background: #06060b;
  color: #999;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  padding: 20px 0;
  line-height: 1.6;
  font-size: 15px;
  .item {
    margin: 0 8px;
    .link {
      color: #999;
      text-decoration: none;
      &:hover {
        color: #1677ff;
        text-decoration: underline;
      }
    }
  }
}
</style>
